
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Pages/home/home.js/home';
import Gallery from './Pages/gallery/gallery';
// import ChatBubble from './components/ChatBubble/ChatBubble';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
        {/* <ChatBubble /> */}
      </BrowserRouter>
    </div>
  );
}

export default App;
